/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Test if a value is a centrosymmetric matrix.
*
* @module @stdlib/assert-is-centrosymmetric-matrix
*
* @example
* var ndarray = require( '@stdlib/ndarray-ctor' );
* var isCentrosymmetricMatrix = require( '@stdlib/assert-is-centrosymmetric-matrix' );
*
* var arr = ndarray( 'generic', [ 2, 1, 1, 2 ], [ 2, 2 ], [ 2, 1 ], 0, 'row-major' );
*
* var bool = isCentrosymmetricMatrix( arr );
* // returns true
*
* bool = isCentrosymmetricMatrix( [] );
* // returns false
*/

// MODULES //

var main = require( './main.js' );


// EXPORTS //

module.exports = main;
